import React, {forwardRef} from 'react';
import {Link as BaseLink} from "@inertiajs/react";

const Link = forwardRef((
    {
        method = 'get',
        as = 'a',
        href,
        data = {},
        active = false,
        className = '',
        children,
        onMouseOver,
        dataSrc,
        only,
        onClick = () => {
        },
    },
    ref
) => {
    return (
        <BaseLink
            method={method}
            as={as}
            data={data}
            href={href}
            ref={ref}
            onClick={onClick}
            className={`${className}${active ? ' active' : ''}`}
            onMouseOver={onMouseOver}
            data-src={dataSrc}
            only={only}
        >
            {children}
        </BaseLink>
    );
});

export default Link;
